const preview = {
  parameters: {
    controls: {
      matchers: {
        color: /(background|color)$/i,
        date: /Date$/,
      },
    },
    layout: 'fullscreen',
    viewport: {
      viewports: {
        mobile: {
          name: 'Mobile',
          styles: {
            width: '390px',
            height: '800px',
          },
        },
        tablet: {
          name: 'Tablet',
          styles: {
            width: '1024px',
            height: '768px',
          },
        },
        desktop: {
          name: 'Desktop',
          styles: {
            width: '1728px',
            height: '1117px',
          },
        },
        
        desktopLarge: {
          name: 'Desktop Large',
          styles: {
            width: '2560px',
            height: '1440px',
          },
        },
      }
    }
  },

  tags: ['autodocs']
};

export default preview;
